import axios from 'axios'
let qs = require('querystring')

const url = process.env.VUE_APP_API_URL

const $axios = axios.create({
    baseURL: url,
})

const post = (url, data) => {
    const request = qs.stringify(data)
    return $axios.post(url, request)
}

const get = (url) => {
    return $axios.get(url)
}

export default {
    post,
    get
}